export default __webpack_public_path__ + "img/dtLaJLkX.feb018c9.svg";